import { GeneralService } from 'src/app/services/general.service';
import { NotificationService } from './../../../services/notification.service';
import { FormularioService } from './../../../services/formulario.service';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AbstractControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { GeneralComponent } from 'src/app/shared/general.component';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'app-cd003-card-VI',
    templateUrl: './cd003-card-VI.component.html'
})

export class Cd003CardVIComponent extends GeneralComponent implements OnInit {
    public formulario?: FormGroup;
    @Output() mkCalc = new EventEmitter();

    // tslint:disable-next-line: max-line-length
    constructor(protected formularioService: FormularioService, protected formBuilder: FormBuilder, protected notificationService: NotificationService, protected generalService: GeneralService) {
        super('Análise da Fração de Sementes Boas e Descarte - Color Sorter', false);
        this.formulario = this.formBuilder.group({
            peso_g_semente_boa_amostra_descarte_cem_g_color_sorter: [null, [Validators.max(100)]],
            peso_g_defeitos_amostra_boa_cem_g_color_sorter: [null, []],
            prc_semente_boa_descarte_color_sorter: [null, []],
            prc_defeitos_bica_boa_color_sorter: [null, []],
        });
    }

    public async ngOnInit(): Promise<void> {
    }

    public changeCollapse(): void {
        this.collapseCard = this.collapseCard ? false : true;
    }

    public hasErrorFormControl(campoFormulario?: AbstractControl): string {
        return this.formularioService.hasErrorFormControl(campoFormulario);
    }

    async makeCalculations(): Promise<void> {
        this.mkCalc.emit();
    }
}

